import { apiClient, ApiName } from '@shared/services/api'

export const fetchTargetTax = (config) => {
  return apiClient.get(ApiName.ADMINS, 'targetTaxes', config)
}

export const deleteTargetTax = (id) => {
  return apiClient.delete(ApiName.ADMINS, 'super/targetTaxes', id)
}

export const createOperationTaxesHomeBroker = (body) => {
  return apiClient.post(ApiName.ADMINS, 'targetTaxes/homeBroker', body)
}
